module.exports = __webpack_public_path__ + "static/media/schedule_a_meeting_hebrew.9e95deec.png";